import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { EndUserProfilesInfo } from '@components/Profile/EndUser/EndUserProfilesInfo';
import { EndUserProfilesTable } from '@components/Profile/EndUser/EndUserProfilesTable';
import { profileApi } from '@reducers/profile/profile';

export const EndUserProfiles = () => (
  <Row>
    <Col>
      <Card className="mb-2">
        <Card.Header className="bg-didxl text-white" />
        <Card.Body>
          <EndUserProfilesInfo />
        </Card.Body>
      </Card>
      <Card>
        <Card.Header className="bg-didxl text-white">
          Existing end-user profiles
        </Card.Header>
        <Card.Body>
          <EndUserProfilesTable useData={profileApi.useGetListQuery} />
        </Card.Body>
      </Card>
    </Col>
  </Row>
);
